var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/folder_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3255 9.32992C18.6156 9.74305 18.2698 10.2474 17.765 10.2474H5.18815C4.78544 10.2474 4.45898 9.92094 4.45898 9.51823V8.18385C4.45898 6.40469 5.90273 4.96094 7.6819 4.96094H9.37357C10.5621 4.96094 10.934 5.3474 11.4079 5.98177L12.4288 7.33802C12.6548 7.63698 12.684 7.67344 13.1069 7.67344H15.1413C16.4571 7.67344 17.6216 8.32757 18.3255 9.32992Z",
    fill: "#42526E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.301 11.3359C18.7028 11.3359 19.0288 11.6609 19.0302 12.0626L19.0423 15.6382C19.0423 17.7893 17.2923 19.5393 15.1413 19.5393H8.36003C6.20898 19.5393 4.45898 17.7893 4.45898 15.6382V12.0653C4.45898 11.6626 4.78544 11.3361 5.18814 11.3361L18.301 11.3359Z",
    fill: "#42526E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.1f0804aec1dd04302396784ffabf6131.svg";
export { ForwardRef as ReactComponent };